import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogStateService } from '../../dialogs/services/dialog-state.service';
import { JssContextService } from '../../jss-context.service';
import { isPlatformServer } from '@angular/common';
import { AB_API_LOGIN, AB_API_QRCODE_STATUS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingInterceptorService implements HttpInterceptor {
  private errorMessage: string;

  constructor(
    private dialogStateService: DialogStateService,
    jssContextService: JssContextService,
    @Inject(PLATFORM_ID) private platform
  ) {
    jssContextService.state.subscribe((context) => {
      if (context && context.sitecore) {
        this.errorMessage =
          context.sitecore.context.errors?.['Application']?.[
            'General'
          ]?.message;
      }
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (isPlatformServer(this.platform)) {
          return throwError(error);
        }

        switch (error.status) {
          case 400:
            this.dialogStateService.openDialog('ErrorHandling', {
              errorDescription: this.errorMessage
            });
            break;
          case 500:
            if (req.url.indexOf('/general/refreshsession') !== -1) {
              return;
            }
            if (req.url.indexOf(AB_API_QRCODE_STATUS) !== -1) {
              return throwError(error);
            }
            if (req.url.indexOf(AB_API_LOGIN) !== -1) {
              return throwError(error);
            }
            this.dialogStateService.openDialog('ErrorHandling', error.error);
            break;
          default:
            break;
        }

        return throwError(error);
      })
    );
  }
}
